import {useTheme} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {FlowEnum} from '../../constants/flowEnum';
import {BookingThemeProps, UseBookingTheme} from './types';

const {successBookingAlert, successExamBookingAlert, successTeleBookingAlert} =
	translations['pt-br'].privateFlow.bookingFlow;
const {consult, exam, surgery} = translations['pt-br'].commons;

export function useBookingTheme({flowType}: UseBookingTheme) {
	const theme = useTheme();

	const bookingTheme: BookingThemeProps = {
		[FlowEnum.HEALTH]: {
			iconName: 'stethoscope',
			iconColor: theme.palette.primary.dark,
			bgColor: theme.palette.primary.shades?.['30p'],
			color: theme.palette.primary.main,
			variant: 'primary',
			specialtyIconName: 'stethoscope',
			alertTitle: successBookingAlert,
			bookingType: consult,
		},
		[FlowEnum.TELEHEALTH]: {
			iconName: 'stethoscope',
			iconColor: theme.palette.primary.dark,
			bgColor: theme.palette.primary.shades?.['30p'],
			color: theme.palette.primary.main,
			variant: 'primary',
			specialtyIconName: 'remember-me-filled',
			alertTitle: successTeleBookingAlert,
			bookingType: consult,
		},
		[FlowEnum.ODONTO]: {
			iconName: 'tooth-outline',
			iconColor: theme.palette.secondary.dark,
			bgColor: theme.palette.secondary.shades?.['30p'],
			color: theme.palette.secondary.main,
			variant: 'secondary',
			specialtyIconName: 'tooth-outline',
			alertTitle: successBookingAlert,
			bookingType: consult,
		},
		[FlowEnum.EXAM]: {
			iconName: 'needle',
			iconColor: theme.palette.customInfo.dark,
			bgColor: theme.palette.customInfo.shades?.['30p'],
			color: theme.palette.customInfo.main,
			variant: 'info',
			specialtyIconName: 'needle',
			alertTitle: successExamBookingAlert,
			bookingType: exam,
		},
		[FlowEnum.SURGERY]: {
			iconName: 'surgical',
			iconColor: theme.palette.primary.dark,
			bgColor: theme.palette.primary.shades?.['30p'],
			color: theme.palette.primary.main,
			variant: 'primary',
			specialtyIconName: 'surgical',
			alertTitle: '',
			bookingType: surgery,
		},
	};

	return bookingTheme[flowType];
}
